import { createTheme } from '@mui/material/styles';

const fontSourceSansRegular = { fontFamily: '"SourceSans Regular", sans-serif' };
const fontsFilter = { fontSize: 14, fontFamily: '"SourceSans Regular", sans-serif' };
const fontMontserratBold = { fontFamily: '"Montserrat Bold", sans-serif' };
const fontMontserratSemibold = { fontFamily: '"Montserrat Semibold", sans-serif' };

/**
 * Font family for main application text like:
 *  - Table content
 *  - Table content UI elements
 *  - Paragraph text
 *  - Body text
 *  - Body text modals
 *  - Body text articles
 */
export const bodyFont = fontSourceSansRegular;

/** Font size and font family for column filters. */
export const filterFonts = fontsFilter;

/**
 * Font family for headings like:
 *  - Headers
 *  - Titles
 *  - Subtitles
 *  - Buttons
 */
export const headingFontBold = fontMontserratBold;

/**
 * Font family for labels like:
 *  - Top nav list
 *  - Top nav project picker
 *  - Logo product name
 *  - Context menu
 */
export const labelFontSemiBold = fontMontserratSemibold;

/** Application Theme. */
const Theme = createTheme({
    palette: {
        primary: {
            main: '#44AC34',
        },
        secondary: {
            main: '#edf2ff',
        },
    },
    typography: {
        h1: {
            ...fontMontserratBold,
        },
        h2: {
            ...fontMontserratBold,
        },
        h3: {
            ...fontMontserratBold,
        },
        h4: {
            ...fontMontserratBold,
        },
        h5: {
            ...fontMontserratBold,
        },
        h6: {
            ...fontMontserratBold,
        },
        body1: {
            ...fontSourceSansRegular,
        },
        body2: {
            ...fontSourceSansRegular,
        },
    },
});

export default Theme;

/** Default application border style. */
export const defaultBorder = `1px solid ${Theme.palette.divider}`;

/** Color variables. */
export const vars = {
    black: '#000' as const,
    concrete: '#898B8E' as const,
    midGray: '#C2C2C2' as const,
    lightGray: '#DEDEDE' as const,
    fillGray: '#F2F2F2' as const,
    bgGray: '#FBFBFB' as const,
    white: '#FFF' as const,
    darkGray: '#696969' as const,

    errorRed: '#B00020' as const,
    errorBgRed: '#F8E6E9' as const,
    errorDialogRed: '#C62C3B' as const,
    errorBorderRed: '#D32F2F' as const,

    font: '#434343' as const,
    placeHolderFont: '#00000061' as const,

    warningYellow: '#F39F18' as const,

    logoBlue: '#0F3949' as const,

    trafficLightGreen: '#A6D326',

    brandGreen: '#44AC34' as const,
    brandOrange: '#FF8400' as const,
    brandPink: '#F8374A' as const,
    brandLightBlue: '#88D2E7' as const,
    brandBlue: '#003C4D' as const,
    brandYellow: '#FBC62A' as const,
    brandDarkBlue: '#245A6D' as const,
    brandDarkBlueSecondary: '#2D7188' as const,

    darkOrange: '#CC6A00' as const,

    hoverGreen: '#2E8B20' as const,
    mainGreen: '#44AC34' as const,
    inactiveGreen: '#8FCD85' as const,
    bgGreen: '#EDF7EB' as const,
    bgGreenHover: '#B4DEAE' as const,
    selectedBgGreen: '#DAEED6' as const,
    selectedHoveredGreen: '#368A2A' as const,
    infoBlue: '#30C1B0' as const,

    red: '#F8374A' as const,

    neonYellow: '#CCE92D' as const,

    chipTeal: '#30C1B0' as const,
    chipDarkBlue: '#1B4452' as const,

    tagChipBlue: '#42B5D3' as const,

    testDoc: '#bb0000' as const,

    disabledGrey: '#00000042' as const,
} as const;

/** Default Action column width. */
export const actionColumnWidth = 96;

/**Height of the each list item on the Project Selection Dropdown */
export const projectSelectionListHeight = 40;

/**Height of the search field inside the Project Selection Dropdown */
export const projectSelectionSearchFieldHeight = 55;

/**Height of the project selection link inside the Project Selection Dropdown */
export const projectSelectionLinkHeight = projectSelectionListHeight;

/**Padding of the project selection link inside the Project Selection Dropdown */
export const projectSelectionLinkPadding = 8;

/**Display none style for the elements that has missing features */
export const displayNoneStyle = { display: 'none' };

export const dataGridRowsHeight = 40;
